import React from "react";
import styles from "./AlertDot.module.scss";

const AlertDot = ({ pulsating = true }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
    >
      {pulsating && (
        <circle
          cx="8"
          cy="8"
          r="7"
          fill={pulsating ? "#E03B24" : "#DEDEE0"}
          className={pulsating ? styles.pulse : ""}
        />
      )}
      <circle cx="8" cy="8" r="3" fill={pulsating ? "#E03B24" : "#DEDEE0"} />
    </svg>
  );
};

export default AlertDot;
